// Configuration file for API server settings
// This allows overriding the default server detection logic
// Useful for VSCode tunnels and other proxy scenarios

export const config = {
  // Set to null to use automatic detection (default behavior)
  // Set to a specific URL to hardcode the API server
  // Examples:
  // - 'http://localhost:8443' for local development
  // - 'https://your-domain.com' for production
  // - 'http://70.42.223.136:8443' for specific IP
  API_SERVER_OVERRIDE: null,
  
  // WebSocket server override
  // Set to null to use automatic detection
  // Set to a specific URL to hardcode the WebSocket server
  // Examples:
  // - 'ws://localhost:8443' for local development
  // - 'wss://your-domain.com' for production  
  WS_SERVER_OVERRIDE: null,
  
  // Force HTTPS API URLs even on HTTP connections
  // Useful when behind certain proxies
  FORCE_HTTPS_API: false,
  
  // Force WSS WebSocket URLs even on HTTP connections
  // Useful when behind certain proxies
  FORCE_WSS: false,
  
  // Disable WebSocket and force HTTP-only mode
  // Useful for debugging connection issues
  DISABLE_WEBSOCKET: false,
  
  // Custom path prefix for API calls
  // Leave empty for root path
  API_PATH_PREFIX: '',
  
  // Connection timeout in milliseconds
  CONNECTION_TIMEOUT: 15000,
  
  // Max reconnection attempts
  MAX_RECONNECT_ATTEMPTS: 5,
  
  // Debug logging options
  LOG_PING_PONG: false  // Set to true to see ping/pong messages
};

// Allow runtime configuration via window object
if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
  Object.assign(config, window.__APP_CONFIG__);
}